export default __webpack_public_path__ + "24b21895461469bef832cf751e729401.gif";